/* ============================================================================
   ACEPLORE · module-reviews.js — progressive "show more" for the reviews list.
   Custom element <lumina-reviews>. Works without JS (all reviews are in the DOM;
   this only collapses extras behind a button when JS is available).
   ========================================================================== */
(function () {
  'use strict';

  if (customElements.get('lumina-reviews')) return;

  var Lumina = (window.Lumina = window.Lumina || {});
  var utils = Lumina.utils || {};
  var Base = Lumina.Element || HTMLElement;

  var qsa = utils.qsa
    ? utils.qsa
    : function (sel, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(sel));
      };

  function LuminaReviews() {
    return Reflect.construct(Base, [], LuminaReviews);
  }
  LuminaReviews.prototype = Object.create(Base.prototype);
  LuminaReviews.prototype.constructor = LuminaReviews;

  LuminaReviews.prototype.connectedCallback = function () {
    this.button = this.querySelector('[data-reviews-more]');
    this.items = qsa('[data-reviews-item]', this);

    var initial = parseInt(this.getAttribute('data-initial'), 10);
    if (isNaN(initial) || initial < 1) initial = 4;
    this.initial = initial;

    if (!this.button || this.items.length <= this.initial) {
      if (this.button) this.button.hidden = true;
      return;
    }

    this.collapse();

    var self = this;
    this._onClick = function () {
      self.expand();
    };

    if (this.listen) {
      this.listen(this.button, 'click', this._onClick);
    } else {
      this.button.addEventListener('click', this._onClick);
      this._fallbackCleanup = function () {
        self.button.removeEventListener('click', self._onClick);
      };
    }
  };

  LuminaReviews.prototype.collapse = function () {
    var self = this;
    this.items.forEach(function (item, i) {
      if (i >= self.initial) {
        item.classList.add('lm-reviews__item--hidden');
      }
    });
    this.button.hidden = false;
    this.button.setAttribute('aria-expanded', 'false');
  };

  LuminaReviews.prototype.expand = function () {
    var hidden = this.items.filter(function (item) {
      return item.classList.contains('lm-reviews__item--hidden');
    });
    hidden.forEach(function (item) {
      item.classList.remove('lm-reviews__item--hidden');
    });
    this.button.setAttribute('aria-expanded', 'true');
    this.button.hidden = true;

    // Move focus to the first newly revealed card heading for keyboard users.
    if (hidden.length) {
      var focusTarget = hidden[0].querySelector('a, h3, [tabindex]') || hidden[0];
      if (focusTarget) {
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({ preventScroll: true });
      }
    }
  };

  // Fallback cleanup when Lumina.Element (auto cleanup) is unavailable.
  LuminaReviews.prototype.disconnectedCallback = function () {
    if (Base.prototype.disconnectedCallback) {
      Base.prototype.disconnectedCallback.call(this);
    }
    if (this._fallbackCleanup) this._fallbackCleanup();
  };

  if (!customElements.get('lumina-reviews')) customElements.define('lumina-reviews', LuminaReviews);
})();
